import { ReactElement } from 'react'
import { Box } from '@mui/material'
import { PanelHeader } from '@ui2/structure'
import { useEditElementStore } from '@editorStores'
import IFCOpeningMultiEdit from '../IFCOpeningMultiEdit'
import IFCPlanarElementForm from '../IFCPlanarElementForm'

/**
 * Editing drawer for planar-model elements (walls, slabs, roof slabs) selected during IFC import
 * via the toolbar planar-model selection mode. Shows a header plus the matching edit form. Wall
 * openings can also be selected (see `useIFCOpeningSelection` on the page) and edited — a single one
 * directly, several aligned together — which takes precedence over the planar element form. While
 * the wall multi-edit is shown, the header is omitted (its "Mehrfachauswahl" section carries the
 * selection summary itself).
 */
const IFCPlanarEditDrawer = (): ReactElement => {
  const multiActiveElements = useEditElementStore(state => state.multiActiveElements)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      {multiActiveElements.length === 0 && (
        <PanelHeader title="Bearbeitung" description="Bearbeiten Sie das ausgewählte Element." />
      )}
      <Box sx={({ palette }) => ({ flex: 1, p: 1.25, backgroundColor: palette.grey[100] })}>
        <IFCOpeningMultiEdit
          emptyState={
            <IFCPlanarElementForm placeholder="Wählen Sie eine Wand, Decke, Dachfläche oder Öffnung im Modell aus, um sie zu bearbeiten." />
          }
        />
      </Box>
    </Box>
  )
}

export default IFCPlanarEditDrawer
